/* Presentation layer; Mono still submits native filtering and sorting. */
(() => {
  if (window.canvoilCollectionRefined) return;
  window.canvoilCollectionRefined = true;
  const collection = document.querySelector('body.template-collection .collections_all_product.canvoil-collection-refined');
  const header = document.querySelector('.section-header');
  if (collection?.querySelector(':scope > .sidebar-vertical')) {
    const toolbar = collection.querySelector(':scope > .sidebar-vertical > .canvoil-collection-toolbar');
    const desktop = window.matchMedia('(min-width: 1200px)');
    let frame = null;
    const setOffset = (name, value) => {
      if (collection.style.getPropertyValue(name) !== value) collection.style.setProperty(name, value);
    };
    const measure = () => {
      frame = null;
      if (!desktop.matches) return;
      // The logo row scrolls away; only the visible header bottom blocks the viewport.
      const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
      const toolbarHeight = toolbar?.getBoundingClientRect().height || 0;
      // Overlap beneath the higher header layer; rounding up exposes product pixels at fractional zoom.
      const toolbarTop = Math.max(0, headerBottom - 1);
      setOffset('--canvoil-toolbar-top', `${toolbarTop}px`);
      setOffset('--canvoil-toolbar-height', `${Math.ceil(toolbarHeight)}px`);
      setOffset('--canvoil-filter-top', `${Math.ceil(toolbarTop + toolbarHeight + 16)}px`);
    };
    const schedule = () => {
      if (desktop.matches && frame === null) frame = requestAnimationFrame(measure);
    };
    const observer = new ResizeObserver(schedule);
    const toggle = () => {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      observer.disconnect();
      if (frame !== null) cancelAnimationFrame(frame);
      frame = null;
      if (!desktop.matches) {
        collection.style.removeProperty('--canvoil-toolbar-top');
        collection.style.removeProperty('--canvoil-toolbar-height');
        collection.style.removeProperty('--canvoil-filter-top');
        return;
      }
      if (header) observer.observe(header);
      if (toolbar) observer.observe(toolbar);
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      measure();
    };
    desktop.addEventListener('change', toggle);
    toggle();
    collection.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      desktop.removeEventListener('change', toggle);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      observer.disconnect();
      if (frame !== null) cancelAnimationFrame(frame);
    }, { once: true });
  }
  document.addEventListener('click', event => {
    const choice = event.target.closest('[data-canvoil-sort]');
    if (choice) {
      const form = choice.closest('form');
      const select = form.querySelector('select[name="sort_by"]');
      select.value = choice.dataset.canvoilSort;
      const menu = choice.closest('details');
      menu.querySelector('.canvoil-sort-value').textContent = choice.textContent;
      menu.querySelectorAll('[data-canvoil-sort]').forEach(button => {
        button.setAttribute('aria-pressed', String(button === choice));
      });
      menu.open = false;
      menu.querySelector('summary').setAttribute('aria-expanded', 'false');
      menu.querySelector('summary').focus();
      select.dispatchEvent(new Event(form.id === 'canvoilMobileSortForm' ? 'change' : 'input', { bubbles: true }));
    }
    document.querySelectorAll('.canvoil-sort-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) {
        menu.open = false;
        menu.querySelector('summary').setAttribute('aria-expanded', 'false');
      }
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.canvoil-sort-menu[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').setAttribute('aria-expanded', 'false');
      menu.querySelector('summary').focus();
    });
  });
})();
